import {BaseApiService} from "./baseApi.service";

export class AddressRegistryService extends BaseApiService {
    constructor() {
        super();
    }

    getCountries () {
        const url = `${process.env.VUE_APP_BASE_URL}/v1/address-service/country`
        return this.sendGetRequest(url)
    }

    getChildren (id) {
        const url = `${process.env.VUE_APP_BASE_URL}/v1/address-service/children?parent=${id}`
        return this.sendGetRequest(url)
    }

    getStreets (ate, streetType) {
        streetType = streetType || 6
        const url = `${process.env.VUE_APP_BASE_URL}/v1/address-service/streets?ate=${ate}&streetType=${streetType}`
        return this.sendGetRequest(url)
    }

    getAteFullPathName(ate, lang) {
        lang = lang || 'ru'
        const url = `${process.env.VUE_APP_BASE_URL}/v1/address-service/ateFullPathName?ate=${ate}&lang=${lang}`
        return this.sendGetRequest(url)
    }
}
